<template>
  <div class="contactusMobile">
    <img src="https://cdn.youjiajk.com/joinBannerMobile.png" width="100%" style="object-fit:cover">
    <img src="https://cdn.youjiajk.com/join1_.png" style="width:100%;height:100%;" />
    <img src="https://cdn.youjiajk.com/join2.png" style="width:100%;height:100%;" />
    <img src="https://cdn.youjiajk.com/join3-1.png" style="width:100%;height:100%;" />
    <div class="careers-row5">
      <div class="comTitle comTitle1">
        我们在寻找优秀的你
      </div>
      <div class="careers-row5-content">
        <div class="careers-row5-contentItem" v-for="(item,index) in inviteList" :key="index">
          <div class="recruitmentTop" @click="item.isShow = !item.isShow">
            <div class="typeTop">
              <div class="top_text">
                <h4>{{item.title}}</h4>
                <div class="text_bottom">
                  <p v-if="item.major">专业：{{item.major}}</p>
                  <p>工作地点:{{item.address}}</p>
                </div>
              </div>
              <img class="icon" src="../../assets/image/bottom.png" width="15" height="13" alt="">
            </div>
          </div>
          <transition name="draw">
            <div class="responsibility" v-show="item.isShow">
              <div class="">
                <h3>岗位职责：</h3>
                <div class="htmlStyle" v-html="item.desc"></div>
                <h3>任职资格：</h3>
                <div class="htmlStyle" v-html="item.desc1"></div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      inviteList: {
        type: Array,
        default: []
      }
    }
  }
</script>

<style lang="less" scoped>
  .contactusMobile {
    display: flex;
    flex-direction: column;

    .careers-row5 {
      margin: 0 auto;
      background: #ffffff;
      width: 100%;

      .comTitleSub {
        color: #FD8246;
      }

      .careers-row5-content {
        width: 90%;
        margin: 0 auto;
        padding-bottom: 0.8rem;
        border-top: 0.08rem solid #F5F6F6;

        .careers-row5-contentItem {
          border-bottom: 0.08rem solid #F5F6F6;
          margin: 0 auto;
          font-size: 0.24rem;

          .recruitmentTop {
            padding: 0.2rem 0;

            .typeTop {
              width: 100%;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: space-around;

              .top_text {
                flex: 1;

                h4 {
                  margin-bottom: 0.08rem;
                }

                .text_bottom {
                  p {
                    &:first-child {
                      margin-top: 0.1rem;
                    }
                  }
                }
              }

              .icon {
                margin-top: 0.2rem;
                width: 0.3rem;
                height: 0.14rem;
              }
            }
          }

          .responsibility {
            height: auto;
            overflow: hidden;
            >div {
              margin-top: 0.2rem;
              background: rgb(244, 245, 248);
              padding: 0.6rem 0.3rem;

              p {
                font-size: 0.24rem;
                font-weight: 300;
                color: #333333;
                line-height: 0.4rem;
              }
            }
          }

          .draw-enter-active,
          .draw-leave-active {
            transition: all 2s ease;
          }

          .draw-enter,
          .draw-leave-to {
            height: 0;
          }
        }
        .htmlStyle{
          line-height: 0.6rem;
          font-size: 0.24rem;
          p {
            
          }
        }
      }
    }
  }

  .comTitle {
    margin: auto;
    text-align: center;
    padding: 0.8rem 0.75rem 0.3rem;
    font-size: 0.4rem;
    line-height: 0.6rem;
    font-weight: 500;
    color: #333333;
  }

  img {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/mobile/contactusMobile.vue